export const PERMISSION_LIST = "PERMISSION_LIST";

export interface PermissionResponse {
  group_name: string;
  permissions: string[];
}
export interface PermissionList {
  permission_list: string[];
}
